// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore,connectFirestoreEmulator, getDoc,getDocs,updateDoc,  query, where,doc,collection} from 'firebase/firestore';
import { getAuth,connectAuthEmulator} from 'firebase/auth';




const {
    REACT_APP_FIREBASE_API_KEY,
    REACT_APP_AUTH_DOMAIN,
    REACT_APP_PROJECT_ID,
    REACT_APP_STORAGE_BUCKET,
    REACT_APP_MESSAGING_SENDER_ID,
    REACT_APP_APP_ID,
    REACT_APP_MEASUREMENT_ID,
    REACT_APP_ENV,
} = process.env;

const firebaseConfig = {
    apiKey: REACT_APP_FIREBASE_API_KEY,
    authDomain: REACT_APP_AUTH_DOMAIN,
    projectId: REACT_APP_PROJECT_ID,
    storageBucket: REACT_APP_STORAGE_BUCKET,
    messagingSenderId: REACT_APP_MESSAGING_SENDER_ID,
    appId: REACT_APP_APP_ID,
    measurementId: REACT_APP_MEASUREMENT_ID,
};

// Initialize Firebase
const firebaseInstance = initializeApp(firebaseConfig);

const firebaseFire  = getFirestore(firebaseInstance);
const firebaseAuth = getAuth(firebaseInstance);

console.log(REACT_APP_ENV);
if(REACT_APP_ENV == "local") {
    connectAuthEmulator(firebaseAuth, "http://127.0.0.1:8086", { disableWarnings: true });
    connectFirestoreEmulator(firebaseFire,"127.0.0.1",8080);
}


export {firebaseAuth,firebaseFire};

// getAnalytics(firebaseInstance);
